'use strict';

(function () {
    let timerIntervals = [];

    function initCountdownTimer() {
        // Clear any existing intervals
        timerIntervals.forEach((interval) => clearInterval(interval));
        timerIntervals = [];

        const timers = document.querySelectorAll('.announcement-bar__timer');

        timers.forEach((timer) => {
            const cutoffTime = timer.dataset.cutoffTime;
            const timerLabel = timer.dataset.timerLabel || '';
            const expiredMessage =
                timer.dataset.expiredMessage || 'Same-day delivery unavailable';
            const timerValue = timer.querySelector(
                '.announcement-bar__timer-value'
            );
            const timerLabelElement = timer.querySelector(
                '.announcement-bar__timer-label'
            );

            if (!cutoffTime || !timerValue) return;

            function formatTime(seconds) {
                const hours = Math.floor(seconds / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const secs = seconds % 60;

                return `${String(hours).padStart(2, '0')}:${String(
                    minutes
                ).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
            }

            function updateTimer() {
                const now = new Date();
                const [hours, minutes] = cutoffTime.split(':').map(Number);

                // Create cutoff time for today only
                const cutoff = new Date();
                cutoff.setHours(hours, minutes, 0, 0);
                cutoff.setSeconds(0);
                cutoff.setMilliseconds(0);

                // Calculate difference in milliseconds
                const diff = cutoff - now;
                const secondsRemaining = Math.floor(diff / 1000);

                // If cutoff time has passed today, show expired (don't countdown to tomorrow)
                if (secondsRemaining <= 0 || cutoff < now) {
                    // Timer expired - cutoff time has passed for today
                    timer.classList.add('timer-expired');
                    timerValue.textContent = expiredMessage;
                    if (timerLabelElement) {
                        timerLabelElement.textContent = '';
                    }
                    timer.setAttribute('aria-label', expiredMessage);
                } else {
                    // Timer active - counting down to today's cutoff time
                    timer.classList.remove('timer-expired');
                    const timeString = formatTime(secondsRemaining);
                    timerValue.textContent = timeString;
                    if (timerLabelElement && timerLabel) {
                        timerLabelElement.textContent = timerLabel;
                    } else if (timerLabelElement) {
                        timerLabelElement.textContent = '';
                    }
                    const hoursRemaining = Math.floor(secondsRemaining / 3600);
                    const minutesRemaining = Math.floor(
                        (secondsRemaining % 3600) / 60
                    );
                    const secsRemaining = secondsRemaining % 60;
                    timer.setAttribute(
                        'aria-label',
                        `${hoursRemaining} hours, ${minutesRemaining} minutes, ${secsRemaining} seconds remaining for same-day delivery`
                    );
                }
            }

            // Initial update
            updateTimer();

            // Update every second (1000ms)
            const interval = setInterval(updateTimer, 1000);
            timerIntervals.push(interval);
        });
    }

    function announcement() {
        const swiperAnnouncement = document.querySelector('.announcement-bar');
        if (swiperAnnouncement) {
            let {
                autoplay,
                delay,
                pauseOnMouseEnter,
                loop,
                speed,
                slidesPerView,
            } = swiperAnnouncement.dataset;
            pauseOnMouseEnter == 'true'
                ? (pauseOnMouseEnter = true)
                : (pauseOnMouseEnter = false);
            loop == 'true' ? (loop = true) : (loop = false);
            if (autoplay == 'true') {
                autoplay = {
                    delay: +delay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: pauseOnMouseEnter,
                };
            } else {
                autoplay: false;
            }
            const swiperAnnouncementBar = new Swiper(
                '.announcement-bar .swiper',
                {
                    lazy: false,
                    pagination: false,
                    navigation: false,
                    slidesPerView: 1,
                    keyboard: {
                        enabled: true,
                    },
                    mousewheel: true,
                    autoplay,
                    loop: +loop,
                    speed: +speed,
                    breakpoints: {
                        1166: {
                            slidesPerView: +slidesPerView,
                        },
                    },
                }
            );

            // Initialize countdown timer after swiper is set up
            initCountdownTimer();
        } else {
            return;
        }
    }

    document.addEventListener('DOMContentLoaded', announcement);
    document.addEventListener('shopify:section:load', announcement);
    window.addEventListener('resize', announcement);
})();
